import React from 'react';
import { useRouting } from 'hooks/useRouting';
import Modal2 from 'components/commons/modal/Modal2';

export const NotGetAssetsInfoModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  const routing = useRouting();
  const goSecurityaccounts = (): void => {
    hide();
    routing.pushRouting({ path: '/securityaccounts' }, true);
  };

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-col text-sm text-bluegray-700">
            <div className="flex flex-row items-baseline">
              <div className="icon-alert items-start h-5 text-red pr-2"></div>
              <div className="text-base font-bold">
                一部の資産情報が取得できませんでした。
              </div>
              <div
                className="icon-close ml-auto text-gray-500"
                onClick={hide}
              />
            </div>
            <div className="mt-2">
              口座連携に失敗している金融商品があります。
            </div>

            <div className="mt-4 font-bold">
              評価額が薄い灰色で表示されている場合
            </div>
            <div>
              当日のデータ取得に失敗しています。
              <br />
              口座連携がエラー表示になっていないか口座連携一覧よりご確認をお願いします。
            </div>
            <div
              className="mt-2 text-link"
              onClick={(): void => goSecurityaccounts()}>
              連携口座一覧
            </div>

            <div className="mt-4 font-bold">前日比が「---」の場合</div>
            <div className="">
              前日もしくは当日のデータ取得に失敗しています。次回の更新までお待ちください。
            </div>
            <button
              className="mt-2 p-2 text-bluegray-550 justify-center w-full"
              onClick={hide}>
              閉じる
            </button>
          </div>
        </div>
      </Modal2>
    </>
  );
};
